import { render, staticRenderFns } from "./pointMallBox.vue?vue&type=template&id=06673e89&scoped=true"
import script from "./pointMallBox.vue?vue&type=script&lang=js"
export * from "./pointMallBox.vue?vue&type=script&lang=js"
import style0 from "./pointMallBox.vue?vue&type=style&index=0&id=06673e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06673e89",
  null
  
)

export default component.exports